export const SUBMIT = 'workload/SUBMIT';
export const CREATED = 'workload/CREATED';
export const CANCEL = 'workload/CANCEL';
export const CHECK_STATUS = 'workload/CHECK_STATUS';
export const UPDATE_STATUS = 'workload/UPDATE_STATUS';
